import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import SellOutlined from '@mui/icons-material/SellOutlined';
import { formatDateFromISO } from '@practium/shared';
import { useEffect, useRef } from 'react';
import styles from './PolicyEditorInputs.module.css';

interface PolicyEditorInputsProps {
	title: string;
	description: string;
	version: string;
	effectiveDate: string;
	isActive: boolean;
	lastEditedAt: string;
	onTitleChange: (value: string) => void;
	onDescriptionChange: (value: string) => void;
	onVersionChange: (value: string) => void;
	onEffectiveDateChange: (value: string) => void;
}

export const PolicyEditorInputs = ({
	title,
	description,
	version,
	effectiveDate,
	isActive,
	lastEditedAt,
	onTitleChange,
	onDescriptionChange,
	onVersionChange,
	onEffectiveDateChange,
}: PolicyEditorInputsProps) => {
	const titleRef = useRef<HTMLTextAreaElement>(null);
	const descRef = useRef<HTMLTextAreaElement>(null);
	const getStatusText = () => (isActive ? 'ATIVO' : 'INATIVO');

	const adjustHeight = (el: HTMLTextAreaElement | null) => {
		if (!el) return;
		el.style.height = 'auto';
		el.style.height = `${el.scrollHeight}px`;
	};

	useEffect(() => {
		adjustHeight(titleRef.current);
	}, [title]);

	useEffect(() => {
		adjustHeight(descRef.current);
	}, [description]);

	useEffect(() => {
		adjustHeight(titleRef.current);
		adjustHeight(descRef.current);
	}, []);

	return (
		<div className={styles.wrapper}>
			<div className={styles.statusHeader}>
				<span className={styles.statusBadge}>{getStatusText()}</span>
				<span className={styles.lastEdited}>Última edição: {formatDateFromISO(lastEditedAt)}</span>
			</div>

			<textarea
				ref={titleRef}
				className={styles.titleInput}
				value={title}
				onChange={(e) => {
					onTitleChange(e.target.value);
					adjustHeight(titleRef.current);
				}}
				placeholder="Título da política"
				rows={1}
			/>

			<textarea
				ref={descRef}
				className={styles.descriptionInput}
				value={description}
				onChange={(e) => {
					onDescriptionChange(e.target.value);
					adjustHeight(descRef.current);
				}}
				placeholder="Descrição breve da política"
				rows={1}
			/>

			<div className={styles.metaInfo}>
				<div className={styles.metaItem}>
					<SellOutlined className={styles.metaIcon} />
					<span className={styles.metaLabel}>Versão</span>
					<input
						type="text"
						className={styles.metaInput}
						value={version}
						onChange={(e) => onVersionChange(e.target.value)}
						onBlur={() => {
							const v = version.trim();
							if (v && !v.includes('.')) onVersionChange(`${v}.0`);
						}}
					/>
				</div>
				<div className={styles.metaItem}>
					<CalendarTodayOutlined className={styles.metaIcon} />
					<span className={styles.metaLabel}>Vigência</span>
					<input
						type="text"
						className={styles.metaInput}
						value={formatDateFromISO(effectiveDate)}
						onChange={(e) => onEffectiveDateChange(e.target.value)}
						placeholder="DD/MM/AAAA"
					/>
				</div>
			</div>
		</div>
	);
};
